import _Number$isNaN from 'babel-runtime/core-js/number/is-nan';
import _extends from 'babel-runtime/helpers/extends';

var NAMESPACE = 'td';

// import { throttle } from 'src/utils/util'

var InputNumber = { render: function render() {
    var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;return _c('div', { staticClass: "td-input-number", class: { 'is-disabled': _vm.disabled } }, [_c('span', { staticClass: "td-input-number__down", class: { 'is-disabled': _vm.isDecreaseDisabled }, on: { "mousedown": function mousedown($event) {
          !_vm.isDecreaseDisabled && _vm.handleDecreaseMouseDown();
        }, "mouseup": function mouseup($event) {
          _vm.decreaseButtonMouseDown = false;
        }, "click": function click($event) {
          return _vm.handleClickSpan('decrease');
        } } }, [_c('i', { staticClass: "td-icon-minus" })]), _vm._v(" "), _vm._t("prepend"), _vm._v(" "), _c('label', { staticClass: "td-input" }, [_c('input', _vm._g({ ref: "input", staticClass: "td-input__inner", attrs: { "type": "text", "placeholder": "1" }, domProps: { "value": _vm.displayValue }, on: { "keydown": [function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) {
            return null;
          }$event.preventDefault();return _vm.handleIncrease($event);
        }, function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) {
            return null;
          }$event.preventDefault();return _vm.handleDecrease($event);
        }] } }, _vm.listeners))]), _vm._v(" "), _vm._t("append"), _vm._v(" "), _c('span', { staticClass: "td-input-number__up", class: { 'is-disabled': _vm.isIncreaseDisabled }, on: { "mousedown": function mousedown($event) {
          !_vm.isIncreaseDisabled && _vm.handleIncreaseMouseDown();
        }, "mouseup": function mouseup($event) {
          _vm.increaseButtonMouseDown = false;
        }, "click": function click($event) {
          return _vm.handleClickSpan('increase');
        } } }, [_c('i', { staticClass: "td-icon-plus" })])], 2);
  }, staticRenderFns: [],
  name: NAMESPACE + '-input-number',

  components: {},

  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    min: {
      type: Number,
      default: -Infinity
    },
    max: {
      type: Number,
      default: Infinity
    },
    value: {
      type: [Number],
      default: 0.0
    },
    step: {
      type: Number,
      default: 1
    },
    precision: {
      type: Number,
      default: 0
    }
  },

  data: function data() {
    return {
      userInput: null,
      displayValue: 0,
      increaseButtonMouseDown: false,
      decreaseButtonMouseDown: false,
      hasChangedViaMouseDown: false
    };
  },

  computed: {
    listeners: function listeners() {
      return _extends({}, this.$listeners, {
        input: this.handleInput,
        change: this.handleInputChange
      });
    },
    isIncreaseDisabled: function isIncreaseDisabled() {
      return this.value >= this.max;
    },
    isDecreaseDisabled: function isDecreaseDisabled() {
      return this.value <= this.min;
    }
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler(newVal, oldVal) {
        var nextValue = +newVal;
        if (_Number$isNaN(nextValue)) {
          nextValue = oldVal;
        }
        nextValue = this.normalizeValue(nextValue);
        this.displayValue = nextValue.toFixed(this.precision);
      }
    }
  },
  methods: {
    // 覆盖默认的Input handler, 否则导致输入异常
    handleInput: function handleInput(e) {},
    normalizeValue: function normalizeValue(value) {
      if (value >= this.max) {
        value = this.max;
      } else if (value <= this.min) {
        value = this.min;
      }
      return parseFloat(Math.round(value * Math.pow(10, this.precision)) / Math.pow(10, this.precision));
    },
    handleInputChange: function handleInputChange() {
      var nextValue = +this.$refs['input'].value;
      if (_Number$isNaN(nextValue)) {
        nextValue = this.value;
      }
      nextValue = this.normalizeValue(nextValue);
      this.$emit('input', nextValue);
      // this.displayValue = nextValue.toFixed(this.precision)
      this.$forceUpdate();
    },
    handleDecrease: function handleDecrease() {
      this.hasChangedViaMouseDown = false;
      var nextValue = Math.max(this.value - this.step, this.min);
      nextValue = this.normalizeValue(nextValue);
      this.$emit('input', nextValue);
      // this.displayValue = nextValue.toFixed(this.precision)
    },
    handleIncrease: function handleIncrease() {
      var nextValue = Math.min(this.value + this.step, this.max);
      nextValue = this.normalizeValue(nextValue);
      this.$emit('input', nextValue);
      // this.displayValue = nextValue.toFixed(this.precision)
    },

    // 修复同时触发长按 和 点击的边界条件， 比如 click 刚好 持续100ms， 这时候就会一次点击触发两次 `change`
    handleClickSpan: function handleClickSpan(operation) {
      if (this.hasChangedViaMouseDown) {
        this.hasChangedViaMouseDown = false;
        return;
      }
      if (operation === 'increase') {
        this.handleIncrease();
      } else {
        this.handleDecrease();
      }
    },
    handleIncreaseMouseDown: function handleIncreaseMouseDown() {
      var _this = this;

      this.increaseButtonMouseDown = true;
      var interval = setInterval(function () {
        if (_this.increaseButtonMouseDown && !_this.isIncreaseDisabled) {
          _this.hasChangedViaMouseDown = true;
          _this.handleIncrease();
        } else {
          window.clearInterval(interval);
        }
      }, 150);
    },
    handleDecreaseMouseDown: function handleDecreaseMouseDown() {
      var _this2 = this;

      this.decreaseButtonMouseDown = true;
      var interval = setInterval(function () {
        if (_this2.decreaseButtonMouseDown && !_this2.isDecreaseDisabled) {
          _this2.hasChangedViaMouseDown = true;
          _this2.handleDecrease();
        } else {
          window.clearInterval(interval);
        }
      }, 150);
    }
  }
};

InputNumber.install = function (Vue) {
  Vue.component(InputNumber.name, InputNumber);
};

export default InputNumber;
